<p>
  Du bist noch <span class="highlight">UNSICHER</span>,
was Du nach der Schule machen
möchtest?</p>
<p>
Woher sollst Du wissen, welcher
<span class="highlight">BERUFLICHE WEG</span> zu Dir
passt?<br>
</p>
<p>
<span class="highlight">ORIENTANDO</span> hilft Dir dabei.
Denn wir räumen auf - mit den
gängigsten Vorurteilen und den
häufigsten Missverständnissen
rund ums Thema Ausbildung &
Studium.
</p>
